import SubjectView from './SubjectView'

export default SubjectView
